// Country calling codes for the phone input on registration.
// [ISO 3166-1 alpha-2, English name, dial code without "+"]
// Azerbaijan and Turkey are intentionally not listed.
export const COUNTRY_CODES = [
    ["AM", "Armenia", "374"],
    ["RU", "Russia", "7"],
    ["US", "United States", "1"],
    ["CA", "Canada", "1"],
    ["FR", "France", "33"],
    ["GE", "Georgia", "995"],
    ["IR", "Iran", "98"],
    ["DE", "Germany", "49"],
    ["GB", "United Kingdom", "44"],
    ["AE", "United Arab Emirates", "971"],
    ["AF", "Afghanistan", "93"],
    ["AL", "Albania", "355"],
    ["DZ", "Algeria", "213"],
    ["AD", "Andorra", "376"],
    ["AO", "Angola", "244"],
    ["AR", "Argentina", "54"],
    ["AU", "Australia", "61"],
    ["AT", "Austria", "43"],
    ["BH", "Bahrain", "973"],
    ["BD", "Bangladesh", "880"],
    ["BY", "Belarus", "375"],
    ["BE", "Belgium", "32"],
    ["BZ", "Belize", "501"],
    ["BJ", "Benin", "229"],
    ["BT", "Bhutan", "975"],
    ["BO", "Bolivia", "591"],
    ["BA", "Bosnia and Herzegovina", "387"],
    ["BW", "Botswana", "267"],
    ["BR", "Brazil", "55"],
    ["BN", "Brunei", "673"],
    ["BG", "Bulgaria", "359"],
    ["BF", "Burkina Faso", "226"],
    ["BI", "Burundi", "257"],
    ["KH", "Cambodia", "855"],
    ["CM", "Cameroon", "237"],
    ["CV", "Cape Verde", "238"],
    ["CF", "Central African Republic", "236"],
    ["TD", "Chad", "235"],
    ["CL", "Chile", "56"],
    ["CN", "China", "86"],
    ["CO", "Colombia", "57"],
    ["KM", "Comoros", "269"],
    ["CG", "Congo", "242"],
    ["CD", "Congo (DRC)", "243"],
    ["CR", "Costa Rica", "506"],
    ["CI", "Côte d'Ivoire", "225"],
    ["HR", "Croatia", "385"],
    ["CU", "Cuba", "53"],
    ["CY", "Cyprus", "357"],
    ["CZ", "Czechia", "420"],
    ["DK", "Denmark", "45"],
    ["DJ", "Djibouti", "253"],
    ["DO", "Dominican Republic", "1"],
    ["EC", "Ecuador", "593"],
    ["EG", "Egypt", "20"],
    ["SV", "El Salvador", "503"],
    ["GQ", "Equatorial Guinea", "240"],
    ["ER", "Eritrea", "291"],
    ["EE", "Estonia", "372"],
    ["SZ", "Eswatini", "268"],
    ["ET", "Ethiopia", "251"],
    ["FJ", "Fiji", "679"],
    ["FI", "Finland", "358"],
    ["GA", "Gabon", "241"],
    ["GM", "Gambia", "220"],
    ["GH", "Ghana", "233"],
    ["GR", "Greece", "30"],
    ["GT", "Guatemala", "502"],
    ["GN", "Guinea", "224"],
    ["GW", "Guinea-Bissau", "245"],
    ["GY", "Guyana", "592"],
    ["HT", "Haiti", "509"],
    ["HN", "Honduras", "504"],
    ["HK", "Hong Kong", "852"],
    ["HU", "Hungary", "36"],
    ["IS", "Iceland", "354"],
    ["IN", "India", "91"],
    ["ID", "Indonesia", "62"],
    ["IQ", "Iraq", "964"],
    ["IE", "Ireland", "353"],
    ["IL", "Israel", "972"],
    ["IT", "Italy", "39"],
    ["JM", "Jamaica", "1"],
    ["JP", "Japan", "81"],
    ["JO", "Jordan", "962"],
    ["KZ", "Kazakhstan", "7"],
    ["KE", "Kenya", "254"],
    ["KW", "Kuwait", "965"],
    ["KG", "Kyrgyzstan", "996"],
    ["LA", "Laos", "856"],
    ["LV", "Latvia", "371"],
    ["LB", "Lebanon", "961"],
    ["LS", "Lesotho", "266"],
    ["LR", "Liberia", "231"],
    ["LY", "Libya", "218"],
    ["LI", "Liechtenstein", "423"],
    ["LT", "Lithuania", "370"],
    ["LU", "Luxembourg", "352"],
    ["MO", "Macao", "853"],
    ["MG", "Madagascar", "261"],
    ["MW", "Malawi", "265"],
    ["MY", "Malaysia", "60"],
    ["MV", "Maldives", "960"],
    ["ML", "Mali", "223"],
    ["MT", "Malta", "356"],
    ["MR", "Mauritania", "222"],
    ["MU", "Mauritius", "230"],
    ["MX", "Mexico", "52"],
    ["MD", "Moldova", "373"],
    ["MC", "Monaco", "377"],
    ["MN", "Mongolia", "976"],
    ["ME", "Montenegro", "382"],
    ["MA", "Morocco", "212"],
    ["MZ", "Mozambique", "258"],
    ["MM", "Myanmar", "95"],
    ["NA", "Namibia", "264"],
    ["NP", "Nepal", "977"],
    ["NL", "Netherlands", "31"],
    ["NZ", "New Zealand", "64"],
    ["NI", "Nicaragua", "505"],
    ["NE", "Niger", "227"],
    ["NG", "Nigeria", "234"],
    ["KP", "North Korea", "850"],
    ["MK", "North Macedonia", "389"],
    ["NO", "Norway", "47"],
    ["OM", "Oman", "968"],
    ["PK", "Pakistan", "92"],
    ["PS", "Palestine", "970"],
    ["PA", "Panama", "507"],
    ["PG", "Papua New Guinea", "675"],
    ["PY", "Paraguay", "595"],
    ["PE", "Peru", "51"],
    ["PH", "Philippines", "63"],
    ["PL", "Poland", "48"],
    ["PT", "Portugal", "351"],
    ["PR", "Puerto Rico", "1"],
    ["QA", "Qatar", "974"],
    ["RO", "Romania", "40"],
    ["RW", "Rwanda", "250"],
    ["SM", "San Marino", "378"],
    ["SA", "Saudi Arabia", "966"],
    ["SN", "Senegal", "221"],
    ["RS", "Serbia", "381"],
    ["SC", "Seychelles", "248"],
    ["SL", "Sierra Leone", "232"],
    ["SG", "Singapore", "65"],
    ["SK", "Slovakia", "421"],
    ["SI", "Slovenia", "386"],
    ["SO", "Somalia", "252"],
    ["ZA", "South Africa", "27"],
    ["KR", "South Korea", "82"],
    ["SS", "South Sudan", "211"],
    ["ES", "Spain", "34"],
    ["LK", "Sri Lanka", "94"],
    ["SD", "Sudan", "249"],
    ["SR", "Suriname", "597"],
    ["SE", "Sweden", "46"],
    ["CH", "Switzerland", "41"],
    ["SY", "Syria", "963"],
    ["TW", "Taiwan", "886"],
    ["TJ", "Tajikistan", "992"],
    ["TZ", "Tanzania", "255"],
    ["TH", "Thailand", "66"],
    ["TG", "Togo", "228"],
    ["TT", "Trinidad and Tobago", "1"],
    ["TN", "Tunisia", "216"],
    ["TM", "Turkmenistan", "993"],
    ["UG", "Uganda", "256"],
    ["UA", "Ukraine", "380"],
    ["UY", "Uruguay", "598"],
    ["UZ", "Uzbekistan", "998"],
    ["VA", "Vatican City", "379"],
    ["VE", "Venezuela", "58"],
    ["VN", "Vietnam", "84"],
    ["YE", "Yemen", "967"],
    ["ZM", "Zambia", "260"],
    ["ZW", "Zimbabwe", "263"],
].map(([iso, name, code]) => ({ iso, name, code }))

export const isKnownDialCode = (code) => COUNTRY_CODES.some(country => country.code === code)
